/* @flow strict */

import * as React from 'react';

type PropsType = {
  onClick?: () => void,
  children?: string
};

const Error = ({
  onClick: handleClick,
  children
}: PropsType): React.Element<'div'> => (
  <div className="Loader__wrapper">
    <span title={children}>
      <button
        className="Loader"
        onClick={handleClick}
      >
        <i
          className="Loader__icon Loader__icon--warning glyphicon glyphicon-info-sign"
          style={{
            fontSize: '2rem'
          }}
        />
        <span>Something went wrong. Try again later.</span>
      </button>
    </span>
  </div>
);

export default Error;
